import {
    FETCH_CLEARANCE,
    FETCH_CLEARANCE_SUCCESS,
    FETCH_CLEARANCE_FAILURE,
    RESET_CLEARANCE,
    RESET_CLEARANCE_FORM,
    FORCE_CLEARANCE_PASS
} from './actions';

export const initialState = () => {
    return {
        isBusy: false,
        data: null,
        formData: null,
        error: null
    };
};

export default function(state = initialState(), action) {
    switch (action.type) {
        case FETCH_CLEARANCE:
            return {
                ...state,
                isBusy: true,
                formData: action.value.data,
                error: null
            };
        case FETCH_CLEARANCE_SUCCESS:
            return {
                ...state,
                isBusy: false,
                data: action.value
            };
        case FETCH_CLEARANCE_FAILURE:
            return {
                ...state,
                isBusy: false,
                error: action.value
            };
        case RESET_CLEARANCE:
            return {
                ...state,
                data: null
            };
        case RESET_CLEARANCE_FORM:
            return {
                ...state,
                formData: null
            };
        case FORCE_CLEARANCE_PASS:
            const data = { ...state.data };
            data.status = data.status === 'pending' ? 'pending' : 'pass';
            data.matches = null;

            return {
                ...state,
                data
            };
        default:
            return state;
    }
}
